import { FleekError } from './FleekError';

export class DeploymentInProgressError extends FleekError<object> {
  public name = 'DeploymentInProgressError';

  toString = () => 'Deployment is already in progress.';
}
